module.exports = __webpack_public_path__ + "assets/img/zfy_info.8766fad7.png";